export const AssistantCabinet_API = {
  patients: { getAllPatients },
  allPatients: { getPatientFromAllPatients, updatePatientFromAllPatients, getPatient, updatePatient, getPatientQuiz, updatePatientQuiz, getListOfStudyTypes },
  errors: {
    getAllCabinetSurveys,
    getOrganizationCarSurveys,
    carSurveyRegistryGeneration,
    carSurveyPdfGeneration,
    updatePatient
  }
}

//allPatients
function getPatientFromAllPatients(orgId, patientId) {
  return { api: `/api/v1/assistant/study/organizations/${orgId}/patients/${patientId}`, method: 'GET' }
}

function updatePatientFromAllPatients(patientId, resultId) {
  return { api: `/api/v1/assistant/study/patients/${patientId}/results/${resultId}`, method: 'PUT' }
}

function getPatient(userId, patientId, resultId) {
  return { api: `/api/v2/verificationCenters/${userId}/patients/${patientId}/results/${resultId}`, method: 'GET' }
}



function getAllPatients() {
  return { api: '/api/v1/assistant/study/patients?', method: 'GET' }
}

function getAllCarSurveys() {
  return { api: '/api/v1/assistant/study/organizations?', method: 'GET' }
}
function getOrganizationCarSurveys(userId,orgId) {
  return { api: `/api/v2/verificationCenters/${userId}/histories/${orgId}?`, method: 'GET' }
}


function getAllCabinetSurveys(userId) {
  return { api: `/api/v2/verificationCenters/${userId}/cabhistories?`, method: 'GET' }
}

function carSurveyPdfGeneration(orgId) {
  return { api: `/api/v1/assistant/study/organizations/${orgId}/results?`, method: 'GET' }
}

function carSurveyRegistryGeneration(orgId) {
  return { api: `api/v1/assistant/study/organizations/${orgId}/results/registry?`, method: 'GET' }
}

function updatePatient(userId, patientId, resultId) {
  return { api: `/api/v2/verificationCenters/${userId}/patients/${patientId}/results/${resultId}`, method: 'PUT' }
}

function getPatientQuiz(userId, patientId, resultId) {
  return { api: `/api/v2/verificationCenters/${userId}/patientquiz/${patientId}/results/${resultId}`, method: 'GET' }
}

function updatePatientQuiz(userId, patientId, resultId) {
  return { api: `/api/v2/verificationCenters/${userId}/patientquiz/${patientId}/results/${resultId}`, method: 'PUT' }
}

function getListOfStudyTypes() {
  return { api: `/api/v1/doctors/listOfTypes`, method: 'POST' }
}
